import React, { Component } from "react";
import "./Popup.scss";

export default class Popup extends Component {
    constructor() {
        super();
        this.togglePopup = this.togglePopup.bind(this);
        this.state = {
            isPopupActive: false,
            ClassName: "",
            Component: null,
            showInsta: true,
            Head: "תודה לך על השתתפותך.",
            Desc: "לרשימת הזוכים, עקבו אחרינו"
        }
    }
    componentDidMount() {
        window.addEventListener("showpopup", (event) => {
            let obj = event.detail;
            this.setState({
                isPopupActive: true,
                ClassName: obj.ClassName,
                Head: obj.Head ? obj.Head : this.state.Head,
                Desc: obj.Desc ? obj.Desc : this.state.Desc,
                showInsta: obj.showInsta ? obj.showInsta : true
            })
        })
    }
    togglePopup() {
        this.setState({
            isPopupActive: !this.state.isPopupActive
        }, () => {
            if (this.state.isPopupActive == false) {
                window.location.reload();
            }
        })
    }
    render() {
        return (
            <div className={`popup-helper ${this.props.className} ${this.state.ClassName}`} style={{ display: this.state.isPopupActive ? "block" : "" }} onClick={this.togglePopup}>
                <div className="fade"></div>
                <div className="padding">
                    <div className="close" onClick={this.togglePopup}></div>
                    <div className="container">
                        <div className="wrapper">
                            <div className="like"></div>
                            <div className="head">{this.state.Head}</div>
                            <div className="desc">{this.state.Desc}</div>
                            {this.state.showInsta ? <a href="https://www.instagram.com/frogifrogi/" title="" target="_blank"><div className="instagram">frogifrogi</div></a> : ""}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/Common/Popup/Popup.jsx